import script from "./BookEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./BookEvent.vue?vue&type=script&setup=true&lang=js"

import "./BookEvent.vue?vue&type=style&index=0&id=743c047f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743c047f"]])

export default __exports__